<template>
  <div class="customizer" id="customizer">
    <div class="inner">
      <Header/>
      <div class="container">
          <ProductOverview/>
          <ProductAttributes/>
      </div>
    </div>
    <confirm-dialog @cancel="cancelConfirmDialog" @confirm="acceptConfirmDialog" />
    <complementary-dialog @cancel="cancelConfirmDialog" @confirm="acceptConfirmDialog" />
  </div>
</template>

<script>
import Header from "./Header";
import ProductOverview from "./ProductOverview";
import ProductAttributes from './ProductAttributes'
import ConfirmDialog from './misc/ConfirmDialog'
import ComplementaryDialog from './misc/ComplementaryDialog'

import ConfirmDialogMixin from '../../mixins/confirm-dialog'

import '../../assets/css/animate.css'
import '../../assets/css/slick.css'

export default {
  name: "CustomizerWrapper",
  components: {Header, ProductOverview, ProductAttributes, ConfirmDialog, ComplementaryDialog},
  mixins: [ConfirmDialogMixin]
}
</script>

<style lang="scss">

.customizer {
  font-family: "neue-haas-grotesk-display",sans-serif;
  padding: 50px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999999999999;
  cursor: default;

  @media (max-width: 768px) {
    padding: 0 20px;
    overflow-y: auto;
  }

  &:before {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #fff;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "neue-haas-grotesk-display",sans-serif;
  }

  .inner {
    max-width: 1220px;
    position: relative;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    height: 100%;
    @media (max-width: 768px) {
      align-items: flex-start;
    }

    .container {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #efefef;
      //flex: 1 0 auto;
      max-height: 650px;
      height: 100%;
      position: relative;
      @media (max-width: 768px) {
        flex-wrap: wrap;
      }

      @media (max-width: 680px) {
        height: auto;
        border-bottom: 0;
      }
    }
  }

}


</style>
